<template>
  <div class="login-fields">
    <b-form-group class="login-field-group">
      <label class="login-field-label" for="login-username">Tên đăng nhập</label>
      <div class="login-input-wrapper">
        <i class="fa-regular fa-user login-input-icon"></i>
        <b-form-input
          id="login-username"
          class="login-input form-control"
          v-model="$v.welcome.username.$model"
          :state="validateState('username')"
          placeholder="vd: nv.linh"
          autocomplete="username"
        ></b-form-input>
      </div>
      <b-form-invalid-feedback class="mt-1">
        Tên đăng nhập không được để trống.
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group class="login-field-group login-password-group">
      <label class="login-field-label" for="login-password">Mật khẩu</label>
      <div class="login-input-wrapper">
        <i class="fa-solid fa-lock login-input-icon"></i>
        <b-form-input
          id="login-password"
          class="login-input form-control login-input-password"
          :type="showPassword ? 'text' : 'password'"
          v-model="$v.welcome.password.$model"
          :state="validateState('password')"
          aria-describedby="password-feedback"
          placeholder="Nhập mật khẩu"
          autocomplete="current-password"
        ></b-form-input>
        <button
          type="button"
          class="login-toggle-password"
          :aria-label="showPassword ? 'Ẩn mật khẩu' : 'Hiện mật khẩu'"
          tabindex="-1"
          @click="showPassword = !showPassword"
        >
          <i
            :class="
              showPassword ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye'
            "
          ></i>
        </button>
      </div>
      <div class="login-forgot-row">
        <a
          href="javascript:void(0)"
          class="login-forgot-link"
          tabindex="-1"
          @click="$emit('forgot-password')"
        >
          Quên mật khẩu?
        </a>
      </div>
      <b-form-invalid-feedback id="password-feedback" class="mt-1">
        Mật khẩu không được để trống.
      </b-form-invalid-feedback>
    </b-form-group>

    <div class="login-remember">
      <b-form-checkbox
        v-model="rememberMe"
        class="login-remember-checkbox"
        tabindex="-1"
      >
        Ghi nhớ đăng nhập trên thiết bị này
      </b-form-checkbox>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { minLength, required } from 'vuelidate/lib/validators';

const REMEMBER_KEY = 'clickbuy_login_remember';
const USERNAME_KEY = 'clickbuy_login_username';

export default {
  props: {},
  mixins: [validationMixin],
  data() {
    return {
      showPassword: false,
      rememberMe: true,
      welcome: {
        username: '',
        password: '',
      },
    };
  },
  validations: {
    welcome: {
      username: {
        required,
        minLength: minLength(3),
      },
      password: {
        required,
        minLength: minLength(3),
      },
    },
  },
  created() {
    this.loadRememberedUsername();
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.welcome[name];
      return $dirty ? !$error : null;
    },
    catchAnyError() {
      this.$v.welcome.$touch();
      return this.$v.welcome.$anyError;
    },
    loadRememberedUsername() {
      try {
        const remembered = localStorage.getItem(REMEMBER_KEY) === 'true';
        const savedUsername = localStorage.getItem(USERNAME_KEY);
        if (remembered && savedUsername) {
          this.rememberMe = true;
          this.welcome.username = savedUsername;
        }
      } catch (e) {
        // ignore storage errors
      }
    },
    persistRememberMe() {
      try {
        if (this.rememberMe) {
          localStorage.setItem(REMEMBER_KEY, 'true');
          localStorage.setItem(USERNAME_KEY, this.welcome.username);
        } else {
          localStorage.removeItem(REMEMBER_KEY);
          localStorage.removeItem(USERNAME_KEY);
        }
      } catch (e) {
        // ignore storage errors
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$login-brand-primary: #26a9b5;

.login-field-group {
  margin-bottom: 1rem;
}

.login-field-label {
  display: block;
  font-size: 0.75rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 0.375rem;
}

.login-password-group {
  position: relative;
}

.login-forgot-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.375rem;
}

.login-forgot-link {
  font-size: 0.75rem;
  font-weight: 600;
  color: $login-brand-primary;
  text-decoration: none;

  &:hover {
    color: #1f8f99;
    text-decoration: underline;
  }
}

.login-input-wrapper {
  position: relative;
}

.login-input-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 0.875rem;
  z-index: 1;
  pointer-events: none;
}

.login-input {
  height: 44px;
  padding: 0 2.75rem 0 2.25rem;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  font-size: 0.875rem;
  background-color: #fff;

  &:focus {
    border-color: $login-brand-primary;
    box-shadow: 0 0 0 3px rgba(38, 169, 181, 0.12);
  }
}

.login-input-password {
  padding-right: 2.75rem;
}

.login-toggle-password {
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: none;
  border: none;
  border-radius: 6px;
  color: #9ca3af;
  cursor: pointer;
  line-height: 1;

  &:hover {
    background: #f3f4f6;
    color: #374151;
  }
}

.login-remember {
  padding-top: 0.25rem;
}

.login-remember-checkbox {
  ::v-deep .custom-control-label {
    font-size: 0.75rem;
    color: #6b7280;
    padding-top: 1px;
  }

  ::v-deep .custom-control-input:checked ~ .custom-control-label::before {
    background-color: $login-brand-primary;
    border-color: $login-brand-primary;
  }

  ::v-deep .custom-control-input:focus ~ .custom-control-label::before {
    box-shadow: 0 0 0 3px rgba(38, 169, 181, 0.12);
  }
}
</style>
